import Axios from '../utils/axios';
import axios from 'axios';
import {environment} from '@gaodun.com/gtools';
import {GetQAUserPSTParams,GetCanAssignedTeacherParams} from '@types';
import { getActiveENV } from '@utils';

const LOWCODE_ENV = {
    test: 'test',
    dev: 'test',
    prepare: 'pre',
    production: 'prod'
};
//@ts-ignore
const getEnv = LOWCODE_ENV[process.env.CROSS_ENV];

export const CancelToken = axios.CancelToken;
export const baseGatewayURL = `https://${getActiveENV()}apigateway.gaodun.com`;
export const http = new Axios({
    baseURL: `https://${getActiveENV()}apigateway.gaodun.com`,
});
export const httpSsm = new Axios({
    baseURL: `https://${getActiveENV()}ssm.gaodun.com`,
});

//http long polling
export const longHttp = new Axios({
    baseURL: `https://${getActiveENV()}apigateway.gaodun.com`,
    timeout: 90000, // 90s
});

//prm
export const prmHttp = new Axios({
    baseURL: `https://${getActiveENV()}prm.gaodun.com`,
});


//所在科目/二级科目，有权限回答的，身份是一线老师，启用状态的账号名单
export const getAllocateRulePstTeacher = (params: any = {}) => http.get('/teaching-workbench/qa/user/allocate/rule/pst/teacher', params);

//依据项目projectID合集获取可指派的老师列表
export const getCanAssignedTeacher = (params: GetCanAssignedTeacherParams) => http.put('/teaching-workbench/qa/user/allocate/rule/apportion/teachers',params);

//获取账号在教研不同工作模式下项目科目
export const getQAUserPST = (params: GetQAUserPSTParams) => http.get('/teaching-workbench/qa/user/pst', params);

//查询指定用户在权限中心（Vigo）的项目权限（course_types）查询项目-科目-二级科目
export const getPSTByVigoUserId = (id: number) => http.post('/teaching-workbench/pst/vigo/user',{vigoUserId:id});

//根据分组编码批量获取
export const getQaDictTypeGroup = (params: any) => http.get('/teaching-workbench/qa/dict/type/group', params);

export const refreshAccessToken = (params: any) => http.formPost('/api/v1/token/refreshtoken', params);

//获取bi登录UserBiToken
export const getUserBiToken = (params: any) => http.get('/vigo/api/v1/getbitoken',params);

export const searchUser = (params?: {
	email?: string;
	fixedTelephone?: string;
	mobile?: number;
	partialPhone?: number;
	userId?: number;
	userName?: string;
	name?: string;
	workNo?: number;
}) => http.get('/vigo/api/v1/users/search', params);

//阿里云视频鉴权
export const reqAliPlayerPlayAuth = (params: any) => http.get('/hermes/front/vod/check-auth', params);

//退出登录
export const userLogout = (params: any) => http.formPost('/api/v1/vigo/logout', params);
//退出登录
export const logoutGtrs = (userId: number|string) => http.get('/teaching-workbench/logout', {userId});

//驳回消息数量
export const getApplyNumber = () => http.get('/teaching-workbench/ask/reject/myself/apply/number');

//获取常量配置的接口
export const getConfigTask = (key:string) => http.get('/space-metis/redis/string',{key});

//获取常量配置的接口
export const getNewRoleList = (vigoUserId:string|number) => http.get('/teaching-workbench/qa/user/roles',{vigoUserId});

// 获取权限路由
// Request URL: https://t-apigateway.gaodun.com/vigo/web/v2/users/1/navigation-functions?appId=211004
export const getNaviFuncListTask = (userId: number): Promise<any> =>
    http.get(`/vigo/web/v2/users/${userId}/navigation-functions`, { 'appId': 211004 });

// 获取查询Schema data
export const getSchemaTask = (key:string) => http.get(`https://apigateway.gaodun.com/yida-server/online-v2/211004/${key}?from=temp&env=${getEnv}`);
// 获取精简回放地址
export const getLiveReplayUrl = (sourceId: string) => http.get(`/hermes/glive/getUrlFromLive/${sourceId}`);

// 获取用户信息
export const getCurrentUserMenuTree = (): Promise<any> => http.post('/api/v1/token/checklogin');


export * from './permission';
export * from './log';
export * from './rule';
export * from './class-allocation';
export * from './message';
export * from './answer-question';
export * from './workplace';
export * from './quick-reply';
export * from './response-time';
export * from './student-record';
export * from './answerqa';
export * from './class-list';
export * from './feedback-list';
export * from './personal-service';
export * from './personal-service-add';
export * from './common-question';
export * from './personal-manage-list';
export * from './team-able-config';
export * from './personal-vip-order';
export * from './mine-book-mark';
export * from './appointment-edit-course';
export * from './luca';

